<template>
  <b-card>
    <div class="row">
      <b-form-group label="Location Type" label-for="location-type" class="col-lg-12">
        <b-select v-model="shoppingDestination._type" id="location-type" name="location-type"
          v-validate="{ required: true }" :state="validateState('shoppingDestination._type')">
          <option :value="null" selected>Select a Type</option>
          <option value="FarmersMarket">Farmers Market</option>
          <option value="FleaMarket">Flea Market</option>
          <option value="OutletMall">Outlet Mall</option>
          <option value="ShoppingCenter">Shopping Center</option>
          <option value="ShoppingDistrict">Shopping District</option>
          <option value="ShoppingMall">Shopping Mall</option>
        </b-select>
      </b-form-group>
      <div class="red"><font-awesome-icon v-if="veeErrors.first('location-type')" icon="exclamation-circle" size="1x"
          style="color:red;" class=" mr-1 fas fa-exclamation-circle" />{{ veeErrors.first('location-type') }}</div>
    </div>

    <div class="row">

      <TelephoneInput label="Telephone" id="phone" name="phone" v-model="shoppingDestination.phone" @input="dirty = true"
        @change="onChange" class="phone-group col-lg-6" />

      <!-- <b-form-group label="Telephone" label-for="phone" class="phone-group col-lg-6">
        <b-form-input type="tel" id="phone" name="phone" v-mask="'(###) ###-####'" @input="dirty=true" v-model="shoppingDestination.phone" @change="onChange" />
      </b-form-group> -->

      <b-form-group label="Hours Of Operation" label-for="hoursOfOperation" class="col-lg-6">
        <b-form-input id="hours" name="hours" v-model="shoppingDestination.hoursOfOperation" @change="onChange" />
      </b-form-group>
    </div>

    <div class="row mb-3">
      <div class="col-lg-12">
        <b-form-group label="Discounts" class="">
          <b-card>
            <b-form-checkbox-group id="discounts" name="Discounts" v-model="shoppingDestination.discounts"
              @change="onChange" style="column-count: 2;" stacked>
              <b-form-checkbox value="AAA">AAA</b-form-checkbox>
              <b-form-checkbox value="Government">Government</b-form-checkbox>
              <b-form-checkbox value="Military">Military</b-form-checkbox>
              <b-form-checkbox value="Senior">Senior</b-form-checkbox>
            </b-form-checkbox-group>
          </b-card>
        </b-form-group>
      </div>
    </div>

    <b-form-group label="Credit Cards Accepted" label-for="creditCards">
      <credit-cards :value="shoppingDestination.creditCards" v-model="shoppingDestination.creditCards"
        @change="onChange" />
    </b-form-group>

  </b-card>
</template>

<script>
import creditCards from '../../../components/CreditCards.vue';
import TelephoneInput from '../../../components/TelephoneInput.vue';

export default {
  components: {
    creditCards,
    TelephoneInput,
  },
  data() {
    return {
      shoppingDestination: {
        discounts: '',
        creditCards: [],
        phone: '',
      },
    };
  },
  props: ['value'],
  mounted() {
    this.shoppingDestination = this.value;
  },
  methods: {
    onChange() {
      this.$emit('input', this.shoppingDestination);
      this.$emit('change', this.shoppingDestination);
    },
    validateState(ref) {
      if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
  },
};
</script>

<style>
.phone-group,
.discounts-group {
  width: 300px;
}
</style>
